// extracted by mini-css-extract-plugin
module.exports = {"simpleLabel":"toolbarselects_simpleLabel__3Ce-C","choiceBoxes":"toolbarselects_choiceBoxes__1QE4V","simpleField":"toolbarselects_simpleField__1YXpP"};